import { render } from "./todayjiance.vue?vue&type=template&id=0ccdca0e&scoped=true"
import script from "./todayjiance.vue?vue&type=script&lang=js"
export * from "./todayjiance.vue?vue&type=script&lang=js"

import "./todayjiance.vue?vue&type=style&index=0&id=0ccdca0e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccdca0e"]])

export default __exports__